import React from 'react';

const TerminalPage: React.FC = () => {
  return (
    <div style={{ height: 'calc(100vh - 180px)', borderRadius: 12, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
      <iframe
        src="/ttyd/"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          background: '#000',
        }}
        title="Terminal"
      />
    </div>
  );
};

export default TerminalPage;
